import { Card, CardContent, CardHeader } from "@/components/ui/card";

import { Skeleton } from "@/components/ui/skeleton";

export function VoicechatSkeleton() {
  return (
    <div
      className="
          flex flex-col h-full max-w-screen mt-16 pb-0
          md:flex-row md:justify-between md:items-stretch md:pt-2 md:pb-0"
    >
      <div className="flex flex-col md:flex-auto items-center justify-stretch p-2 md:basis-2/5">
        <Card className="w-full">
          <CardHeader className="p-2 gap-2">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-4 w-64" />
          </CardHeader>
          <CardContent className="hidden md:inline">
            <Skeleton className="h-40" />
          </CardContent>
        </Card>
      </div>
      <div className="flex-col flex-auto md:basis-3/5 p-2 md:p-2 min-w-0">
        <Card className="p-2 w-full mb-2 h-14">
          <CardContent className="flex items-center justify-between">
            <Skeleton className="h-10 w-10 rounded-full" />
            <Skeleton className="h-10 w-10 rounded-full" />
          </CardContent>
        </Card>
        <Card className="h-[calc(100dvh-360px)] mb-10 md:mb-0 md:h-[calc(100dvh-200px)] flex flex-col p-0">
          <Card className="h-14 w-full mt-auto">
            <span />
          </Card>
        </Card>
      </div>
    </div>
  );
}
